<section class="call-session-shell" [attr.aria-label]="callAriaLabel">
  <header class="call-session-header">
    <div class="call-session-brand">
      <span class="call-session-brand__logo" aria-hidden="true">
        <img [src]="brand.logoPath" alt="" />
      </span>
      <div>
        <p class="call-session-brand__eyebrow">{{ callEyebrow }}</p>
        <h1>{{ session()?.title || 'Call' }}</h1>
      </div>
    </div>

    <div class="call-session-actions">
      @if (session()?.calendarEventId) {
        <button type="button" mat-stroked-button (click)="openInviteDialog()">
          <mat-icon aria-hidden="true">person_add</mat-icon>
          Add person
        </button>
      }
      <button type="button" mat-stroked-button color="warn" (click)="leave()">
        <mat-icon aria-hidden="true">call_end</mat-icon>
        Leave
      </button>
    </div>
  </header>

  <main class="call-session-stage">
    @if (status() === 'error') {
      <div class="call-session-empty">
        <mat-icon aria-hidden="true">warning</mat-icon>
        <p>{{ errorMessage() || 'We couldn’t load this call session.' }}</p>
        <button type="button" mat-flat-button color="primary" (click)="leave()">Close</button>
      </div>
    } @else {
      <div class="call-session-frame-shell">
        @if (waitingParticipants().length > 0) {
          <aside class="call-session-waiting" aria-label="Waiting room">
            <p class="call-session-waiting__title">Guests waiting</p>
            <div class="call-session-waiting__list">
              @for (p of waitingParticipants(); track p.id) {
                <div class="call-session-waiting__item">
                  <span class="call-session-waiting__name">{{ p.name || 'Guest' }}</span>
                  <button type="button" mat-stroked-button color="primary" (click)="admitWaitingParticipant(p.id)">
                    Admit
                  </button>
                </div>
              }
            </div>
          </aside>
        }

        <div #frameHost class="call-session-frame-host" [attr.aria-label]="dailyCallAriaLabel"></div>
      </div>
    }
  </main>
</section>
